import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

export interface NoDataOverlayProps {
  width: number;
  height: number;
}

export const EmptyChart: React.FC<NoDataOverlayProps> = ({
  width,
  height,
}: NoDataOverlayProps) => {
  const centerX = width / 2;
  const centerY = height / 2;
  const iconSize = 48;
  const fontSize = 14;
  const { t } = useI18nHelper();

  return (
    <g color={"#8F8F8C"}>
      {/* ① 아이콘 */}
      <svg
        x={centerX - iconSize / 2}
        y={centerY - iconSize - 16}
        width={iconSize}
        height={iconSize}
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.70078 4.0833C4.70078 3.6967 4.38738 3.3833 4.00078 3.3833C3.61418 3.3833 3.30078 3.6967 3.30078 4.0833V20.0833C3.30078 20.4699 3.61418 20.7833 4.00078 20.7833H20.0008C20.3874 20.7833 20.7008 20.4699 20.7008 20.0833C20.7008 19.6967 20.3874 19.3833 20.0008 19.3833H4.70078V16.8866L11.9851 10.0575L14.5058 12.5783C14.7792 12.8516 15.2224 12.8516 15.4958 12.5783L19.9958 8.07828C20.2691 7.80491 20.2691 7.36169 19.9958 7.08833C19.7224 6.81496 19.2792 6.81496 19.0058 7.08833L15.0008 11.0934L12.4958 8.58833C12.2286 8.32117 11.7977 8.31422 11.522 8.57262L4.70078 14.9675V4.0833Z"
          fill="currentColor"
        />
      </svg>

      {/* ② 텍스트 */}
      <text
        x={centerX}
        y={centerY}
        textAnchor="middle"
        fill="#444444"
        fontSize={fontSize}
      >
        {/* 첫 번째 줄: 중앙에서 위쪽으로 살짝 올리기 */}
        <tspan x={centerX} dy={-fontSize * 0.1}>
          {t("markup_chart_first_line")}
        </tspan>
        {/* 두 번째 줄: 첫 줄 기준으로 아래에 배치 */}
        <tspan x={centerX} dy={fontSize * 1.4}>
          {t("markup_chart_second_line")}
        </tspan>
      </text>
    </g>
  );
};
